export default "__VITE_ASSET__BK8Srg3s__"